export default __webpack_public_path__ + "static/media/steam.840878ac.svg";